module.exports = __webpack_public_path__ + "static/media/empty-close.d3c732bf.svg";